
import { Component } from '@angular/core';
import { NotificacionesComponent } from '../General/notificaciones.component';
@Component({
    selector: 'oaj-no-notificadas-itx',
    templateUrl: 'noNotificadas.component.html',
    styleUrls: ['noNotificadas.component.css'],
    imports: [NotificacionesComponent]

})
export class NoNotificadasComponent {
    loading = false;
}